import Grid from '@mui/material/Grid';

import styles from 'assets/css/Hypo.module.css';
import { HypoButton } from './HypoButton';
import { useState } from 'react';
import { HypoChart } from './HypoChart';

export const NumberHypoEventPart = ({ HypoglycemiaChartData,patientId }) => {
  const [active, setActive] = useState('total');
  return (
    <Grid container style={{ backgroundColor: '#FFFFFF' }}>
      <Grid
        container
        style={{ padding: '16px 27px 0px 17px', backgroundColor: '#FFFFFF' }}
      >
        <p className={styles.partTitle}> : تعداد رویداد های هایپوگلیسمی</p>
        <HypoChart
          HypoglycemiaChartData={HypoglycemiaChartData}
          active={active}
        />
      </Grid>
      <HypoButton active={active} setActive={setActive} patientId={patientId}/>
    </Grid>
  );
};
